const PATIENT_ROLE_PATTERN = /^(患者|患者端|患者用户|patient|patientuser|patientrole)$/i

function roleValueMatches(value) {
  if (typeof value !== 'string') return false
  return PATIENT_ROLE_PATTERN.test(value.trim().toLowerCase().replace(/[\s_-]/g, ''))
}

function collectRoleValues(value, values) {
  if (!value) return
  if (typeof value === 'string') {
    value.split(',').forEach(item => values.push(item))
    return
  }
  if (Array.isArray(value)) {
    value.forEach(item => collectRoleValues(item, values))
    return
  }
  if (typeof value === 'object') {
    ;['name', 'roleName', 'code', 'roleCode', 'description'].forEach(key => {
      if (typeof value[key] === 'string') values.push(value[key])
    })
  }
}

export function isPatientRole(userInfo) {
  if (!userInfo || typeof userInfo !== 'object') return false
  const values = []
  ;['roleName', 'roleNames', 'role', 'roles', 'roleList', 'authorities'].forEach(key => {
    collectRoleValues(userInfo[key], values)
  })
  return values.some(roleValueMatches)
}



// WEBPACK FOOTER //
// ./src/utils/role.js